import { DialogContent } from '@mui/material'
import type { Control } from 'react-hook-form'
import { Controller } from 'react-hook-form'

import type { ImportProgress, SqlImportFormValues } from '@/features/sqlImport/types'

import {
	ImportErrorContent,
	ImportIdleContent,
	ImportProgressContent,
	ImportSuccessContent,
} from './'

interface ImportDialogContentProps {
	control: Control<SqlImportFormValues>,
	errors: {
		selectedFile?: { message?: string }
		sqlText?: { message?: string }
	},
	inputMode: 'file' | 'paste'
	onFileSelect: (files: File[]) => Promise<void>,
	onSqlTextChange: (value: string) => Promise<void>,
	progress: ImportProgress,
	selectedFile: File | null,
	sqlText: string
}

export const ImportDialogContent = ({
	progress,
	control,
	inputMode: _inputMode,
	selectedFile,
	sqlText,
	errors,
	onFileSelect,
	onSqlTextChange,
}: ImportDialogContentProps) => {
	return (
		<DialogContent>
			{progress.status === 'idle' && (
				<Controller
					name="inputMode"
					control={control}
					render={({ field }) => (
						<ImportIdleContent
							inputMode={field.value}
							onInputModeChange={field.onChange}
							onFileSelect={onFileSelect}
							onSqlTextChange={onSqlTextChange}
							selectedFile={selectedFile}
							sqlText={sqlText}
							fileError={errors.selectedFile?.message || ''}
							textError={errors.sqlText?.message || ''}
						/>
					)}
				/>
			)}

			{progress.status === 'importing' && (
				<ImportProgressContent progress={progress} />
			)}

			{progress.status === 'success' && (
				<ImportSuccessContent progress={progress} />
			)}

			{progress.status === 'error' && (
				<ImportErrorContent progress={progress} />
			)}
		</DialogContent>
	)
}

